import { IEnvironmentFromFile } from './environment.types'

export const environmentDev: IEnvironmentFromFile = {
  ADOBE_DTM: 'launch-EN4784749e433243eb8208fac004e2b1d9-development',
  IDS_AUTH_KEY: 'oxford-user:https://identity-dev.cinch.co.uk/:fe',
  AUTH0_AUTH_KEY:
    'oxford-user:https://auth-dev.cinch.co.uk:GnTyrV9M8uSC94BY0X2PBB9rX5mwmHuU',
  CINCHCARE_SERVICE_URL: 'https://cinchcare.cnv-dev.aws.cinch.co.uk',
  PERMISSION_URL: 'https://permissions.snc-dev.aws.cinch.co.uk/unsubscribe',
  DELIVERY_SERVICE_URL: 'https://delivery.dev.api.cinch.co.uk',
  ORDER_SERVICE_URL: 'https://orders.dev.api.cinch.co.uk',
  PROFILE_SERVICE_URL: 'https://profile.onr-dev.aws.cinch.co.uk',
  SEARCH_SERVICE_URL: 'https://search-api.snc-dev.aws.cinch.co.uk',
  SEARCH_CHANNEL_ID: 'CINCH',
  SETTLEMENT_SERVICE_URL: 'https://settlement.dev.api.cinch.co.uk',
  SEGMENT_KEY: '2EDvvodmSFPCpQV2U4a7GtoV2sxRDNsX',
  STATIC_ASSETS_URL: 'https://assets-dev.cinch.co.uk',
  IDENTITY_SERVICE_URL: 'https://api-dev.cinch.co.uk/idt/v1',
  AUTH0_SERVICE_URL: 'https://auth-dev.cinch.co.uk',
  AUTH0_DATABASE_NAME: 'Username-Password-Authentication',
  AUTH0_CLIENT_ID: 'GnTyrV9M8uSC94BY0X2PBB9rX5mwmHuU',
  PROMO_BANNER_NAME: 'new-cars',
  CINCH_URL: 'https://cambridge.preview.aws.cinch.co.uk',
  CINCH_APP_URL: 'https://mobile.snc-dev.aws.cinch.co.uk',
  TRUSTPILOT_URL: 'https://trustpilot.snc-dev.aws.cinch.co.uk',
  STORYBLOK_BFF_COMPONENT: 'https://storyblok-bff.snc-dev.aws.cinch.co.uk',
  CONSUMER_VALUATIONS_SERVICE_URL:
    'https://consumer-valuations.cnv-dev.aws.cinch.co.uk',
  CINCH_CHARGE_CARD_REQUEST_URL:
    'https://extras-cinch-charge-card.cnv-dev.aws.cinch.co.uk',
  CINCH_CHARGE_CARD_REQUEST_API_KEY: '9IHPexNUQG1RAnKt6D0Aj7gCpMbVjklaaLMir7vG',
  PRODUCT_DETAIL_SERVICE_URL: 'https://product.dev.api.cinch.co.uk',
  RESERVATION_STATUS_URL:
    'https://orders.dev.api.cinch.co.uk/reservation-status',
  INVENTORY_SERVICE_HISTORY_URL:
    'https://service-history.dev.api.cinch.co.uk/basic',
  IOS_APP_STORE_URL:
    'https://apps.apple.com/gb/app/cinch-cars-without-the-faff/id1641060889',
  ANDROID_APP_STORE_URL:
    'https://play.google.com/store/apps/details?id=com.cinchapp',
  ADMIN_FEE_RETURN_TO_CHECKOUT: 'true',
  ADMIN_FEE_VALUE: '9900',
  ADMIN_FEE_LOYALTY: 'true',
  UNSUBSCRIBE_SERVICE_URL:
    'https://communication-v2-user-prefs.dev.api.cinch.co.uk/unsubscribe',
  UNSUBSCRIBE_MINIMUM_DURATION: '3000',
  CHECKOUT_RESERVATIONS_DECOUPLING: 'true',
  CHECKOUT_RESERVATIONS_DECOUPLING_PHASE_TWO: 'false',
  RESERVATION_SERVICE_URL:
    'https://reservations.cnv-dev.aws.cinch.co.uk/source/orders',
  DELIVERY_SLOT_AVAILABILITY_SERVICE_URL:
    'https://delivery.dev.api.cinch.co.uk/delivery-slots',
  LOGISTICS_FEES_SERVICE_URL: 'https://logistics-fees.snp-dev.aws.cinch.co.uk',
  LOGISTICS_ROUTING_SERVICE_URL:
    'https://logistics-routing.snp-dev.aws.cinch.co.uk',
  FINANCE_APPLICATION_SERVICE_URL:
    'https://finance-application.dev.api.cinch.co.uk',
  FINANCE_OFFER_SERVICE_URL: 'https://finance-offer.dev.api.cinch.co.uk',
  FINANCE_SERVICE_URL: 'https://finance.dev.api.cinch.co.uk',
  FINANCE_QUOTE_SERVICE_URL: 'https://finance-quote.pnf-dev.aws.cinch.co.uk',
  FINANCE_SOFT_SEARCH_URL_PATH: '/finance-eligibility',
  PAYMENT_LINK_SERVICE_URL: 'https://payment-link.cnv-dev.aws.cinch.co.uk',
  STRIPE_PUBLISHABLE_KEY: 'pk_test_oWH3UdQU6FjMhxofexsj2LbB00JJTg5bhT',
  GAP_SERVICE_URL: 'https://gap-insurance.cnv-dev.aws.cinch.co.uk',
  SERVICING_AND_WARRANTY_FLAG: 'false',
  DISABLE_CINCHCARE: 'false',
  GAP_INSURANCE_FLAG: 'true',
  CUSTOMER_DATA_API_KEY: '579faa1b-87e1-44c0-bdbb-5ed3e4f2239c',
  CUSTOMER_DATA_API_URL: 'https://customer-data.dev.api.cinch.co.uk',
  SEARCH_MULTIPLE_IMAGES: 'true',
  ENABLE_ZENDESK_SCRIPT: 'true',
  VEHICLE_CARD_V2: 'true',
  VEHICLE_OWNERSHIP_SERVICE_URL:
    'https://vehicle-ownership.onr-dev.aws.cinch.co.uk',
  ENABLE_BUY_NOW_CTA_MESSAGING: 'true',
  ENABLE_EMAIL_QUOTE: 'true',
  HOMEPAGE_FAVOURITING: 'true',
  ENABLE_PRODUCT_DETAIL_PAGE_VARIANT: 'true',
  ENABLE_QUOTES_MARKETING: 'true',
  SEARCH_FINANCE_TYPE_FILTER: 'true',
  SHOW_QUOTE_TERM_MONTHS: 'true',
  SHOW_SCORELESS_TRUSTPILOT: 'true',
  SOFT_SEARCH_CHANGES: 'true',
  PDP_SOFT_SEARCH: 'true',
  SHOW_CINCH_COVER_IN_PROFILE: 'true',
  SHOW_TYRE_INSURANCE_IN_PROFILE: 'true',
  SHOW_MULTI_TERM_VAPS_IN_PROFILE: 'true',
  SHOW_GAP_INSURANCE_IN_PROFILE: 'true',
  SHOW_SELF_SERVICE_RENEWALS_V3: 'true',
  BANK_SERVICE_URL: 'https://bank-details.cnv-dev.aws.cinch.co.uk',
  VAP_SERVICE_URL: 'https://yybmpue166.execute-api.eu-west-1.amazonaws.com/dev',
  USE_REFRESH_TOKEN: 'true',
  SHOW_HELP_AND_SUPPORT_CHANGES: 'true',
  HELP_AND_SUPPORT_URL: 'https://help.cinch-dev.co.uk/hc/en-gb/',
  SEARCH_FINANCE_CALCULATOR_CTA: 'true',
  ENABLE_SEGMENT_TRACKING_IN_USED_CARS: 'true',
  SEARCH_DATA_DRIVEN_SORT_ORDER: 'true',
  NAVBAR_VALUATION_EXPERIMENT_ID: 'value-my-car-cta-dev',
  GOOGLE_GEOCODING_API_KEY: 'AIzaSyDzCFu8k1pee9xWv_pCgEw6py_xF3ZjFJs',
  STORE_AVAILABILITY_URL: 'https://store-availability.snp-dev.aws.cinch.co.uk',
  STORE_AVAILABILITY_KEY: 'O0gQHv0g58aMWaPKQCVAK6la4sbrA1zQ947VCUJe',
  GOOGLE_MAPS_BASE_URL: 'https://maps.googleapis.com/maps/api',
  SEARCH_FINANCE_CALCULATOR_CTA_EXPERIMENT_ID: 'search-page-finance-cta-dev',
  VEHICLE_PURCHASE_BASE_URL: 'https://vehicle-purchase.cnv-dev.aws.cinch.co.uk',
  SEARCH_DATA_DRIVEN_SORT_EXPERIMENT_ID: 'search-price-sort-dev',
  ENABLE_SELL_MY_CAR: 'true',
  ENABLE_NEW_PROFILE_HEADER: 'true',
  FINANCE_APPLICATION_CHECKOUT_BANNER: 'true',
  CAR_FINANCE_SHOW_TRUST_PILOT: 'true',
  SEARCH_FREE_COLLECTION_LABELS_EXPERIMENT_ID:
    'search-free-collection-labels-dev',
  SEARCH_FREE_COLLECTION_LABELS: 'true',
  SITES_BASE_URL: 'https://sites.service.cinch-dev.co.uk',
  SITES_API_KEY: 'SUBNxFWXVF6ROFYFNIFOg3hNmXy0CsMTVe9vSi6a',
  ENABLE_NEW_CARS: 'true',
  ENABLE_NEW_CARS_FINANCE: 'true',
  ENABLE_NEW_CARS_SEO: 'true',
  ENABLE_VAPS_FEATURE_CAR_MAINTENANCE: 'true',
  ENABLE_MARSHALL_COLLECTION_TRIAL: 'true',
  CAR_OVERVIEW_ACCORDIONS_EXPERIMENT_ID: 'pdp-open-accordion-dev',
  LEAD_GEN_SERVICE_URL: 'https://cinch-lead-generation.snc-dev.aws.cinch.co.uk',
  FIN_OFFER_COMMISSION: 'true',
  EVOLUTION_IDD_URL:
    'https://www.evolutionfunding.com/public/initial-disclosure-document/',
  FINANCE_SDD_PDF: 'Cinch_SDD_v02.pdf',
  FINANCE_COMMISSION_PDF: 'commissionV6.pdf',
  MARSHALL_PRIVACY_POLICY_URL:
    'https://www.marshall.co.uk/site/privacy-notice/',
  MARSHALL_COMMISSION_STATEMENT_URL:
    'https://www.marshall.co.uk/site/finance-commission-disclosure-statement/',
  NEW_CARS_API_URL: 'new-cars',
  SEARCH_NEW_CARS: 'true',
  FINANCE_SOFT_SEARCH_V2: 'true',
  FINANCE_SOFT_SEARCH_URL_V2:
    'https://finance-soft-search.pnf-dev.aws.cinch.co.uk',
  ENABLE_COMPARE_BUTTON: 'true',
  FINANCE_APPLICATION_ADDRESS_HISTORY_SUBBUILDING: 'true',
  CINCH_SERVICING_URL: 'https://cinch-servicing.onr-dev.aws.cinch.co.uk',
  NEW_CARS_FILTERS_FLAG: 'true',
  PROPOSAL_SUBMISSION_URL:
    'https://proposal-submission.pnf-dev.aws.cinch.co.uk',
  PROPOSAL_SUBMISSION_API_KEY: 'v0iOfcUcU9OmnmKwF09TkZVSvYdw5r51qDutZo80',
  ENABLE_SERVICE_BOOKING: 'true',
  IDEAL_POSTCODES_URL: 'https://api.ideal-postcodes.co.uk',
  IDEAL_POSTCODES_API_KEY: 'test-key',
  AWIN_SERVICE_URL: 'https://awin.cnv-dev.aws.cinch.co.uk',
  PART_EX_EQUITY_RELEASE: 'true',
  SEARCH_NEW_CAR_FAVOURITING: 'true',
  ENABLE_LOOPING_CAROUSEL_IMPRESSION_TRACKING: 'true',
  SEARCH_NEW_CARS_SIGN_POST_BANNER: 'true',
  SEARCH_DYNAMIC_FIN_REP: 'true',
  SEARCH_ZERO_PERCENT_APR: 'true',
  SEARCH_VIRTUAL_STOCK: 'true',
}
